import { performPostRequestWithToken } from "../service/network/NetworkService";
import { getClassFromIntent } from "./utils/ClassFromIntent";

/**
 * Intent executor in the system is used start the execution of intent.
 */

let intentInstance;

class IntentExecutor {
  constructor() {
    if (intentInstance) return;
    intentInstance = this;
  }

  executeIntent = async (intent, payload, context, rootView) => {
    const intentHandler = getClassFromIntent(intent);
    return intentHandler.processIntent(intent, payload, context, rootView);
  };

  executeApiCall = async (url, payload) => {
    const result = await performPostRequestWithToken(url, JSON.stringify(payload));
    const resultJson = await result.json();
    return resultJson;
  };
}

export default IntentExecutor;
